import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { ApplicantInput } from "../types/Applicant";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_APPLICANTS_FETCH_KEY } from "./useGetApplicants";
import { AxiosError } from "axios";

export const updateApplicant = async (
  id: string,
  updatedApplicant: Partial<ApplicantInput>,
): Promise<ApplicantInput> => {
  const response = await fetcher.put(
    `${API.GESLUB}/productApplicant/${id}`,
    updatedApplicant,
  );
  return response.data;
};

export const useUpdateApplicant = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ApplicantInput,
    AxiosError<{ message: string }>,
    { id: string; updatedApplicant: Partial<ApplicantInput> }
  >({
    mutationFn: async ({ id, updatedApplicant }) => {
      return updateApplicant(id, updatedApplicant);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_APPLICANTS_FETCH_KEY] });
    },
  });
  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
